import React from 'react';
import propTypes from 'prop-types';

/**
 * centered muted line used for the empty and error states of the home cards
 * @param children - text to render
 */
export default function CardMessage({ children }) {
  return (
    <p className='m-0 py-4 text-center text-sm text-grey-light'>{children}</p>
  );
}

CardMessage.propTypes = {
  children: propTypes.node.isRequired
};
